'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _immutableHelper = require('../../../common/utils/immutableHelper');

var _Icon = require('../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _LinkButton = require('../../components/buttons/LinkButton');

var _LinkButton2 = _interopRequireDefault(_LinkButton);

var _elementAttachmentActions = require('../elementAttachmentActions');

require('./ImageErrorContent.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Utils


// Components


// Actions


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchClearError: function dispatchClearError(id) {
            return dispatch((0, _elementAttachmentActions.clearElementAttachmentError)({ id: id }));
        }
    };
};

var ImageErrorContent = function (_React$Component) {
    _inherits(ImageErrorContent, _React$Component);

    function ImageErrorContent() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ImageErrorContent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ImageErrorContent.__proto__ || Object.getPrototypeOf(ImageErrorContent)).call.apply(_ref, [this].concat(args))), _this), _this.clearError = function () {
            var _this$props = _this.props,
                elementId = _this$props.elementId,
                dispatchClearError = _this$props.dispatchClearError;

            dispatchClearError(elementId);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ImageErrorContent, [{
        key: 'render',
        value: function render() {
            var error = this.props.error;


            return _react2.default.createElement(
                'div',
                { className: 'ImageErrorContent' },
                _react2.default.createElement(_Icon2.default, { name: 'error-alert' }),
                _react2.default.createElement(
                    'span',
                    { className: 'details' },
                    (0, _immutableHelper.prop)('message', error) || 'Unable to upload image',
                    _react2.default.createElement('br', null),
                    (0, _immutableHelper.prop)('explanation', error) || 'Sorry, something went wrong'
                ),
                _react2.default.createElement(
                    _LinkButton2.default,
                    { className: 'cta', onClickFn: this.clearError },
                    'Try another image'
                )
            );
        }
    }]);

    return ImageErrorContent;
}(_react2.default.Component);

ImageErrorContent.propTypes = {
    error: _propTypes2.default.object,
    dispatchClearError: _propTypes2.default.func,
    elementId: _propTypes2.default.string,
    imageConnectDropTarget: _propTypes2.default.func,
    imageIsHovered: _propTypes2.default.bool,
    imageCanDrop: _propTypes2.default.bool
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(ImageErrorContent);


//////////////////
// WEBPACK FOOTER
// ./src/client/element/image/ImageErrorContent.js
// module id = 1980
// module chunks = 0